import { render } from "./ProductOptionCreate.vue?vue&type=template&id=4219823e"
import script from "./ProductOptionCreate.vue?vue&type=script&lang=js"
export * from "./ProductOptionCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__